<template lang="pug">
#aviso-selecionar-territorio(v-if='shouldShowAviso')
    el-alert(
        :title='$t("laudos.avisoPadrao")',
        type='warning',
        show-icon,
        close-text='',
        :closable='true'
    )
</template>

<script>
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';

export default {
    name: 'AvisoSelecionarTerritorio',
    props: {
        tipoLaudo: {
            type: Number,
            required: true
        }
    },
    computed: {
        shouldShowAviso() {
            const laudosQueMostramAviso = [
                TipoLaudo.AVALIACAO_SOCIOAMBIENTAL,
                TipoLaudo.DINAMICA_EXPLORACAO,
                TipoLaudo.SUPRESSAO_VEGETAL_RED_YELLOW_FLAG,
                TipoLaudo.CARBONO,
                TipoLaudo.CONFORMIDADE,
                TipoLaudo.RENOVABIO
            ];
            return laudosQueMostramAviso.includes(this.tipoLaudo);
        }
    }
};
</script>

<style lang="scss">
#aviso-selecionar-territorio {
    margin-bottom: 20px;
}
</style>
